// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__j8+TR","badge":"tabs_badge__DPLzu","badge-yellow":"tabs_badge-yellow__FGpnb","badge-green":"tabs_badge-green__fug-v","badge-red":"tabs_badge-red__G2qN2"};